import { Typography } from '@mui/material';
import { IssueAverageAgeReportResult } from '@tap/data-providers';
import { PeriodSelectType, PeriodSelectTypeSpec, Widget } from '@tap/mui-ui';
import { ChartCustom, CustomChartTooltip } from '@tap/tap-ui';
import { dateTimeHelper } from '@tap/utils';
import {
    XAxis, YAxis, CartesianGrid,
    Tooltip as RechartsTooltip, Bar, BarChart,
} from 'recharts';

/* График Средняя длительность незавершённых заявок
*/

const getMaxValue = (initialData: IssueAverageAgeReportResult[]) => {
    const tasksQuantityList = initialData?.map(item => item.avgTime);
    return Math.max(...tasksQuantityList) || 1;
};

type AverageAgeChartProps = {
    reportData: IssueAverageAgeReportResult[],
    periodType: PeriodSelectType,
}


export default function AverageAgeChart({ reportData, periodType }: AverageAgeChartProps) {

    const maxValue = getMaxValue(reportData);

    return (
        <Widget title={`График показывает среднюю длительность для незавершённых заявок за последние ${PeriodSelectTypeSpec[periodType].daysQuantity} дней`}>
            <ChartCustom>
                <BarChart data={reportData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        type="category"
                        dataKey="date"
                        scale={'auto'}
                        tick={{ dy: 5, fontSize: '12px' }}
                        tickFormatter={(date: any) => dateTimeHelper.format(date, 'd MMM', true) || date}
                    />
                    <YAxis
                        dataKey='avgTime'
                        domain={[0, maxValue]}
                        tick={{ fontSize: '12px' }}
                    />
                    <RechartsTooltip
                        wrapperStyle={{ outline: 'none' }}
                        content={
                            <CustomChartTooltip
                                labelTemplate={(label) => {
                                    return dateTimeHelper.format(label, 'd MMMM yyyy');
                                }}
                                valueTemplate={payload =>
                                    <>
                                        <Typography sx={{ color: 'black' }}>Незавершённые заявки: {payload.payload?.tasksCount}</Typography>
                                        <Typography>{payload.name}: {payload.value}</Typography>
                                    </>
                                }
                            />
                        }
                    />
                    <Bar
                        opacity={.8}
                        name={'Среднее количество дней'}
                        dataKey="avgTime"
                        stroke={'#2196f3'}
                        fill={'#2196f3'}
                    />
                </BarChart>
            </ChartCustom>
        </Widget>
    );
}

